<xi-warning-popup
  [title]="title"
  [subtitle]="content"
  [isVisible]="true"
  [buttons]="popupButtons"
  (onProceed)="confirm()"
  (onCancel)="cancel()"
>
</xi-warning-popup>
